import { ColumnTable, Icon, Table } from '@octano/global-ui';
import { useAdmissionStatusList } from '../../../../../admission/contexts/AdmissionStatusListContext';
import { AdmissionManagementFindItem } from '../../../../../admission/types';
import { useTexts } from '../hooks/useTexts';
import { CallStatus } from '../types';
import { callStatusTranslation } from '../utils';
import { BadgeState } from './BadgeState';

export function CalledTable() {
  const { data } = useAdmissionStatusList();
  const texts = useTexts().table;

  const columns: ColumnTable<AdmissionManagementFindItem>[] = [
    {
      columnName: 'postulantIdentificationValue',
      headerText: texts.headers.postulantIdentificationValue,
      thClassName: 'text-center',
      tdClassName: 'text-center',
    },
    {
      columnName: 'postulantFistname',
      headerText: texts.headers.postulantFistname,
      thClassName: 'text-center',
      tdClassName: 'text-center',
    },
    {
      columnName: 'postulantLastname',
      headerText: texts.headers.postulantLastname,
      thClassName: 'text-center',
      tdClassName: 'text-center',
    },
    {
      columnName: 'postulantPhone',
      headerText: texts.headers.postulantPhone,
      thClassName: 'text-center',
      tdClassName: 'text-center',
    },
    {
      columnName: 'postulantEmail',
      headerText: texts.headers.postulantEmail,
      thClassName: 'text-center',
      tdClassName: 'text-center',
    },
    {
      columnName: 'callNumber',
      headerText: texts.headers.callNumber,
      thClassName: 'text-center',
      tdClassName: 'text-center',
      width: '5%',
    },
    {
      columnName: 'callStatus',
      headerText: texts.headers.callStatus,
      thClassName: 'text-center',
      tdClassName: 'text-center',
      width: '15%',
      cellFormat: ({ row }) =>
        row?.callStatus ? (
          <BadgeState
            status={row.callStatus}
            text={callStatusTranslation(row.callStatus)}
          />
        ) : (
          <span>-</span>
        ),
    },
    {
      columnName: 'action',
      headerText: texts.headers.action,
      thClassName: 'text-center',
      tdClassName: 'text-center',
      width: '10%',
      cellFormat: ({ row }) => {
        const allowRemove = row.callStatus === CallStatus.SENT;
        return (
          <span
            className={allowRemove ? 'cursor-pointer' : undefined}
            onClick={() => allowRemove && console.log(row)} //TODO impementar eliminacion
          >
            <Icon name="trash" color={allowRemove ? 'primary' : 'disabled'} />
          </span>
        );
      },
    },
  ];
  return (
    <>
      <div className="fs-20 text-uppercase text-primary fw-700 my-2">
        {texts.title}
      </div>
      <Table data={data.data || []} columns={columns} />;
    </>
  );
}
